import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
  } from "@/components/ui/alert-dialog"
  
  interface RateLimitDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    message: string
  }
  
  export function RateLimitDialog({ open, onOpenChange, message }: RateLimitDialogProps) {
    // Split message into paragraphs
    const paragraphs = message.split('\n\n').filter(p => p.trim())
  
    return (
      <AlertDialog open={open} onOpenChange={onOpenChange}>
        <AlertDialogContent className="max-w-md">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-xl font-semibold text-red-600 dark:text-red-400">
              Daily Limit Reached
            </AlertDialogTitle>
            <AlertDialogDescription className="space-y-4 pt-4">
              {paragraphs.map((paragraph, index) => (
                <p key={index} className="text-base text-foreground leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="!justify-center sm:!justify-center">
            <AlertDialogAction 
              onClick={() => onOpenChange(false)}
              className="bg-primary hover:bg-primary/90 w-32"
            >
              Got it
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    )
  }
  
  